import SeaFooter from './footer-sea';

const Footer = (props) => {
  return <SeaFooter {...props}/>
};

export default Footer;